export const CACHE_KEY_CASE_ID = "caseId"
export const CACHE_KEY_REFERRAL_PACKET = "referralPacket"
